<template>
  <div class="vendor-form">
    <p class="vendor-form-label">
      {{ label
      }}<span class="text-ast" v-show="sublabel"><br />{{ sublabel }}</span>
    </p>
    <div class="form-list-usaha">
      <div class="list-usaha">
        <div class="list-usaha-content list-usaha-content__title">
          <p class="column25 mr5">Nama {{ label }}</p>
          <p class="column20">Nama Kontak</p>
          <p class="column20">Posisi</p>
          <p class="column15">Telepon</p>
          <p class="column10">Email</p>
        </div>
        <div v-for="(list, index) in companies" :key="index">
          <div class="list-usaha-content" v-if="!list.isDelete">
            <p class="column25 mr5">{{ list.company_name }}</p>
            <p class="column20">{{ list.contact_name }}</p>
            <p class="column20">{{ list.position }}</p>
            <p class="column15">
              {{ list.phone ? '+' : ''
              }}{{ list.phone ? $store.state[storeName]['phone_code'] : '' }}
              {{ list.phone }}
            </p>
            <p class="column15">{{ list.email }}</p>
            <p class="column5" @click="edit(list)" v-if="!disabled">
              <i class="fa fa-edit"></i>
            </p>
            <p class="column5" @click="deleteList(list.id)" v-if="!disabled">
              <i class="fas fa-trash-alt"></i>
            </p>
          </div>
        </div>
      </div>
      <div @click="openModal()" class="btn-landing-icons" v-if="!disabled">
        <p class="icons-btn-landing">+</p>
        <p class="text-btn-landing">Tambah</p>
      </div>
    </div>
  </div>
</template>
<script>
import { api_lp } from '@/services/config'
import axios from 'axios'

export default {
  props: [
    'label',
    'sublabel',
    'isRequired',
    'storeName',
    'modelName',
    'modalName',
    'mutationName',
    'arrayMutation',
    'disabled',
  ],
  computed: {
    companies: function () {
      return this.$store.state[this.storeName][this.modelName]
    },
  },
  methods: {
    openModal() {
      this.$store.commit(this.mutationName, {
        name: this.modalName,
        value: true,
      })
      this.$store.commit(this.mutationName, {
        name: 'companies_add',
        value: true,
      })
    },
    edit(list) {
      this.$store.commit(this.mutationName, {
        name: 'companies_id',
        value: list.id,
      })
      this.$store.commit(this.mutationName, {
        name: 'companies_name',
        value: list.company_name,
      })
      this.$store.commit(this.mutationName, {
        name: 'companies_contact',
        value: list.contact_name,
      })
      this.$store.commit(this.mutationName, {
        name: 'companies_position',
        value: list.position,
      })
      this.$store.commit(this.mutationName, {
        name: 'companies_phone',
        value: list.phone,
      })
      this.$store.commit(this.mutationName, {
        name: 'companies_email',
        value: list.email,
      })
      this.$store.commit(this.mutationName, {
        name: 'companies_edit',
        value: true,
      })
      this.$store.commit(this.mutationName, {
        name: this.modalName,
        value: true,
      })
    },
    async deleteList(id) {
      let url = ''
      if (this.modelName == 'child_companies') {
        url = `${api_lp}/api/v1/vendor/child/${id}/${this.$store.state[this.storeName]['request_id']
          }`
      }
      if (this.modelName == 'parent_companies') {
        url = `${api_lp}/api/v1/vendor/parent/${id}/${this.$store.state[this.storeName]['request_id']
          }`
      }

      const { data } = await axios({
        method: 'DELETE',
        url,
      })

      if (data && data.status == 'success') {
        await this.$store.commit(this.mutationName, {
          name: this.modelName,
          value: data.data,
        })
      }
    },
  },
}
</script>
